import { getWindowSize } from '../utils/helpers';
import { updateLinksAttributes } from '../utils/handleAttributes';

export default function mainCards() {
  const widgetName = 'mainCards';
  const widgetOpts = mainCardsOpts;
  const wrapContainerClass = 'mainCards-wrap-container';
  const $widget = $(`#${widgetName}`);
  const isDesktop = getWindowSize(800);
  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktop ? [] : ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 10,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createmainCards(data.items, isDesktop);
      } else {
        $('.mainCards-wrap-container').remove();
      }
    },
  });

  function createmainCards(widgetData, isDesktop) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);
      const customButton = createButton(URL, Title);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
          </div>`);

      $cardItem.find('.image-container').append(customButton);
      updateCardsMobile(isDesktop, $cardItem, URL, Title);
      validateUrl(URL, $cardItem);
    });
  }
}

function validateUrl(url, $cardItem) {
  if ($cardItem && url === null) {
    $cardItem.addClass('void-link');
  }
  return url !== null;
}

function createButton(url, title) {
  let customButton = '';

  if (validateUrl(url)) {
    const label = `More about ${title}`;
    const attrs = updateLinksAttributes(url, label);
    const link = '<a href="' + url + '" ' + attrs + ' class="button">More</a>';
    customButton = '<div class="widget-button-wrapper">' + link + '</div>';
  }
  return customButton;
}

function updateCardsMobile(isDesktop, $cardItem, URL, Title) {
  if (isDesktop) {
    return;
  } else {
    updateLinksAttributes(URL, Title, $cardItem);
  }
}
